import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router';

import { inviteFormType } from 'utils/constants';
import { texts } from 'utils/languages/fr';

import InviteUser from '../servicer-users/InviteUser';
import ProviderTable from './ProviderUserTable';
import { ListContainer } from 'components';

const ProviderUsers = () => {
    const { path } = useRouteMatch();

    return (
        <ListContainer>
            <Switch>
                <Route
                    path={`${path}/invite-provider`}
                    render={() => (
                        <InviteUser
                            title={texts.CREATE_PROVIDER_USER}
                            type={inviteFormType.PROVIDER}
                        />
                    )}
                />
                <Route path={path} component={ProviderTable} />
            </Switch>
        </ListContainer>
    );
};

export default ProviderUsers;
